<h3>Delete {{data.type | titlecase}}</h3>
<div>
  <p>Are you sure to delete the selected item ?</p>
</div>
<div class="mb-1 mt-1">
  <button mat-raised-button (click)="delete()" color="warn">Delete</button>
  <button mat-button (click)="onNoClick()" color="primary" cdkFocusInitial class="ml-2">Cancel</button>
</div>
